<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader :title="`Dashboard`">
      </PageHeader>
    </div>
    <div class="table-wrapper" ref="tableWrapper"> 
      <iframe @load="handleIframeLoad"  ref="myIframe" title="EMSL" 
        :src="powerbiUrl"
        frameborder="0" allowFullScreen="true"></iframe>
      </div>
  </div>
</template>

<script>

export default {
  name: "My-SE",
  data() {
    return {
    };
  },
  computed: {
    isProduction() {
      return process.env.NODE_ENV === 'production';
    },
    powerbiUrl(){
      const urlQa = "https://app.powerbi.cn/reportEmbed?reportId=6724ce86-8580-4063-84fb-a8a73cf9bdf4&navContentPaneEnabled=false&autoAuth=true&ctid=4ffd4ad7-838d-4638-a166-11e219443ad7"
      const urlPrd = "https://app.powerbi.cn/reportEmbed?reportId=3aa5bde9-cb82-43ee-a7b6-997d888d8b92&navContentPaneEnabled=false&autoAuth=true&ctid=4ffd4ad7-838d-4638-a166-11e219443ad7"
      return this.isProduction?urlPrd:urlQa
    }
  },
  created() {
  },
  mounted(){
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustIframeHeight);
  },
  methods: {
   handleIframeLoad() {
      this.adjustIframeHeight();
      window.addEventListener('resize', this.adjustIframeHeight);
    },
    adjustIframeHeight() {
      const iframe = this.$refs.myIframe;
      if (iframe && iframe.contentDocument) {
        const doc = iframe.contentDocument;
        const body = doc.body;
        const html = doc.documentElement;
        iframe.style.height = `${Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        )}px`;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.table-wrapper{
  height:calc(100vh - 50px - 55px - 30px);
   position: relative;
  overflow: hidden;
}
.table-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none; /* 移除默认边框 */
  box-sizing: border-box; /* 确保 padding 和 border 不影响尺寸 */
}
</style>
